import config from "../../config";
import axios from "axios";


    function axios_api(api) {
    axios.defaults.baseURL = api;
    axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
    axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("token-rules")}`; 
    return axios
    }

    async function GetForms(id) {
    let json = []
            if(!id){
                return
            }
            const result = await axios_api(config.api).post(config.api+'/forms',{idformulario:id,FormBuilder:true}).then((res)=>{
            // console.log('id, res.data :', id, res.data);
                return {'data':res.data,'ok':true};
            
            }).catch((error)=>{
                console.log('error:', error);
                return {'data':error,'ok':false}
            });
            console.log('message :', result.data);
            if(result.data.message){
                return {'data':'el id del formulario no existe o el fomulario tiene errores','ok':false};
            }
            if(result.data.error){
                return {'data':result.data.solution,
                        error:result.data.error ,
                        field: result.data.field&& result.data.field,
                        'ok':false};
            }
            for (const key in result.data.form) {
                json.push(JSON.parse(result.data.form[key]));
    
            }
            console.log('result :', result);
            return {'data':json,'ok': result.ok,'entity':result.data.entity};
    }






    async function validateForm(body) {
        const result = await axios_api(config.api+'/valideform').post(config.api+'/valideform',body).then((res)=>{
        return {'data':res.data,'ok':true};
        
        }).catch((error)=>{
        return {'data':error,'ok':false}
        });
        return result;
    }



    async function GetFormularyBySE(id) {
        const result =  await axios_api(config.api+'/formularySE/'+id).get(config.api+'/formularySE/'+id).then((res)=>{
        return {'data':res.data,'ok':true};
        }).catch((error)=>{
        return {'data':error,'ok':false};
        });
        console.log('result$$$ :', result);
        if(result.data.Formulary.length>0){
        return result;
        }else{
        return {'data':result.data,'ok':false}
        }
        
    }



    async function getDocuments(body) {
        console.log('result:',body);
        const result = await axios_api(config.api+'/documents/'+body).get(config.api+'/documents/'+body,body).then((res)=>{
        return {'data':res.data,'ok':true};
        }).catch((error)=>{
        return {'data':error,'ok':false}
        });
        return result;
    }




    async function getDocumentsToSend(body) {
        console.log('result:',body);
        const result = await axios_api(config.api+'/documents/id/'+body).get(config.api+'/documents/id/'+body,body).then((res)=>{
        return {'data':res.data,'ok':true};
        }).catch((error)=>{
        return {'data':error,'ok':false}
        });
        return result;
    }

    async function testApi(body) {
        console.log('result:',body);
        const result = await axios_api('TEST').get('http://localhost:8000/images/MiturLogo.png').then((res)=>{
        return {'data':res.data,'ok':true};
        }).catch((error)=>{
        return {'data':error,'ok':false}
        });
        return result;
    }



    export {
        getDocuments,
        getDocumentsToSend,
        GetFormularyBySE,
        GetForms,
        validateForm,
        testApi
    }





